<template>
    <v-main>
        <v-container fluid>
            <v-row justify="space-between">
                <v-col class="py-0">
                    <v-btn small elevation="0" @click="tableview=!tableview" >
                        <v-icon v-if="!tableview">mdi-table-large</v-icon>
                        <v-icon v-else>mdi-image</v-icon>
                    </v-btn>
                    <v-btn small text  elevation="0" @click="select=!select" :color="select?'primary':'grey-lighten-2'">
                        <v-icon :class="{'grey--text lighten-1':!select}">mdi-checkbox-marked-outline</v-icon>
                    </v-btn>
                    <v-btn small text @click="getFiles()">Update</v-btn>
                    <v-btn small @click="sendTwil()">
                        test
                    </v-btn>
                </v-col>
                <v-col class="py-0 text-right">

                    <span class="caption">
                      {{totalStorage}}
                    </span>
                </v-col>
            </v-row>

            <v-data-table
                    v-if="tableview"
                    :headers="headers"
                    :items="files"
                    item-key="id"
                    class="elevation-0"
                    :search="search"
                    :options="options"
                    :show-select="select"
                    v-model="selected"
                    :mobile-breakpoint="200"
                    @click:row="setSelected($event)"
                    dense
            >
                <template v-slot:top>
                    <v-text-field
                            v-model="search"
                            label="Search"
                            class="mx-4"
                    ></v-text-field>
                </template>
                <template v-slot:item.fname="{ item }">
                    <v-icon class="subtitle-1 mr-1">{{fileType(item.filetype)}}</v-icon>
                    <span class="caption">{{shortenName(item.fname)}}</span>
                    <a :href="item.uri" v-if="['ics','xls','calendar'].includes(item.filetype)" class="ml-2">
                        <v-icon small >{{icons.download}}</v-icon>
                    </a>
                </template>
                <template v-slot:item.uploadedby="{ item }" v-if="$vuetify.breakpoint.smAndUp">
                    <span class="caption">{{item.uploadedby===appdata.partkey?'me':item.owner}}</span>
                </template>
                <template v-slot:item.updatedAt="{ item }" v-if="$vuetify.breakpoint.smAndUp">
                    <span class="caption">
                         {{ item.updatedAt | moment("ddd, MMM D, YYYY, h:mm a") }}
                    </span>
                </template>
                <template v-slot:item.size="{ item }" v-if="$vuetify.breakpoint.mdAndUp">
                    <span class="caption">{{fileSize(item.size)}}</span>
                </template>

            </v-data-table>

            <v-row justify="space-between" v-else>
                <v-col v-for="(f,i) in files" :key="f.key">
                    <v-card @click="activeinfo=f,infodialog=true" style="width:200px;">
                        <v-img
                                aspect-ratio="1"
                                width="200"
                                :src="f.uri"
                        ></v-img>
                        <v-card-actions>
                            <span class="font-weight-light subtitle-2">
                                {{fileSize(f.size)}}
                            </span>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>


            <!--                                            <v-col class="px-0">-->
            <!--                                                <v-btn-->
            <!--                                                    icon-->
            <!--                                                    color="info"-->
            <!--                                                    v-clipboard:copy="f.Key"-->
            <!--                                                    v-clipboard:success="onCopy"-->
            <!--                                                    v-clipboard:error="onError"-->
            <!--                                                >-->
            <!--                                                    <v-icon :class="activecopy===f.Key?'display-2':''">{{icons.link}}</v-icon>-->
            <!--                                                </v-btn>-->
            <!--                                            </v-col>-->

            <!--                                            <v-btn icon @click="deteFile(f.Key,i)" class="px-0" color="red">-->
            <!--                                                <v-icon>-->
            <!--                                                    {{icons.close}}-->
            <!--                                                </v-icon>-->
            <!--                                            </v-btn>-->
            <!--                                        </v-row>-->
        </v-container>


        <v-dialog v-model="infodialog" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card v-if="activeinfo">
                <!--                <v-card-text>-->
                <!--                    {{activeinfo.Size/1000000}}MB-->
                <!--                    -->
                <!--                </v-card-text>-->
                <v-img :src="prefix+activeinfo.key">
                    <v-btn small class="closebtn ol" @click="infodialog=false">
                        <v-icon>{{icons.close}}</v-icon>
                    </v-btn>
                </v-img>
            </v-card>
        </v-dialog>


        <Uploader :fab="true" @newfiles="newFiles($event)"/>
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import AWS from 'aws-sdk'
  import Uploader from "../components/uploader/Uploader";

  export default {
    components: {Uploader},
    name: "MyFiles",
    data: () => ({
      files: [],
      activeinfo: undefined,
      infodialog: false,
      activecopy: undefined,
      search: '',
      options: {
        page: 1,
        itemsPerPage: 200,
        //sortBy: 'updatedAt',
        //sortDesc: true,
        //groupBy: string[],
        //groupDesc: boolean[],
        multiSort: true,
        //mustSort: boolean
      },
      tableview: true,
      select:false,
      selected: []
    }),
    computed: {
      ...mapState(['idpool', 'userpool', 'org', 'icons', 'loggedin', 'appdata']),
      prefix() {
        return `https://orgbucket-${this.org.partkey}.s3-us-west-2.amazonaws.com/`;
      },
      headers() {
        if (this.$vuetify.breakpoint.mdAndUp) {
          return [
            {
              text: 'Name',
              align: 'start',
              sortable: true,
              value: 'fname',
            },
            {text: 'Owner', value: 'uploadedby'},
            {text: 'Last modified', value: 'updatedAt'},
            {text: 'File size', value: 'size'}
          ];
        } else if (this.$vuetify.breakpoint.smAndUp) {
          return [
            {
              text: 'Name',
              align: 'start',
              sortable: true,
              value: 'fname',
            },
            {text: 'Owner', value: 'uploadedby'},
            {text: 'Last modified', value: 'updatedAt'}
          ]
        } else if (this.$vuetify.breakpoint.xsOnly) {
          return [
            {
              text: 'Name',
              align: 'start',
              sortable: true,
              value: 'fname',
            }
          ]
        }
      },
      totalStorage() {
        let v = 0;
        for (const item of this.files) {
          v += item.size;
        }
        return this.fileSize(v);
      },
    },
    mounted() {
      if (!this.org) {
        let em = this;
        setTimeout(function () {
          em.getFiles()
        }, 2000)
      } else {
        this.getFiles()
      }
    },
    methods: {
      //todo Handle ACL of private.. files also needs to be encryptable if requested
      //might as well handle whatsapp stuff as well
      ...mapActions(['post', 'get']),
      async getFiles() {
        let files = await this.get({path: 'api/files/'})
        this.files = files
      },
      fileSize(s) {
        return (s < 1000000) ? (s / 1000).toFixed(2) + ' KB' : (s / 1000000).toFixed(2) + ' MB'
      },
      shortenName(n) {
        return '...' + n.slice(-35);
      },
      fileType(t) {
        if (t === 'png' || t === 'jpg' || t === 'jpeg') {
          return 'mdi-image'
        } else if (t === 'folder') {
          return 'mdi-folder'
        }else if (t==='email'){
          return 'mdi-email'
        }else if (t==='pdf'){
          return 'mdi-file-pdf-box'
        }else if(t==='ics'||t==='calendar'){
          return 'mdi-calendar'
        }
      },

      // async getFiles() {
      //   //SET THIS STUFF GLOBALLY, MAYBE...
      //   let em = this;
      //   let session = await this.$store.dispatch('cognito/fetchSession')
      //   let idKey = 'cognito-idp.us-west-2.amazonaws.com/' + this.userpool
      //   AWS.config.region = 'us-west-2';
      //   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      //     IdentityPoolId: 'us-west-2:298bb257-e38c-4729-a20e-e7f803403933',
      //     Logins: {
      //       [idKey]: session.idToken.jwtToken
      //     }
      //   });
      //   var s3 = new AWS.S3({
      //     apiVersion: '2006-03-01',
      //     params: {
      //       Bucket: 'orgbucket-'+em.org.partkey,
      //     }
      //   });
      //   AWS.config.credentials.get(function (err) {
      //     if (err){
      //       this.disabled=false
      //       return console.log(err)
      //     }
      //     s3.listObjects({Delimiter: '/'}, function(err, data) {
      //       console.log(data)
      //       em.files = data.Contents
      //     })
      //   })
      // },
      async deteFile(key, i) {
        let em = this;
        let session = await this.$store.dispatch('cognito/fetchSession')
        let idKey = 'cognito-idp.us-west-2.amazonaws.com/' + this.userpool
        AWS.config.region = 'us-west-2';
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'us-west-2:298bb257-e38c-4729-a20e-e7f803403933',
          Logins: {
            [idKey]: session.idToken.jwtToken
          }
        });
        var s3 = new AWS.S3({
          apiVersion: '2006-03-01',
          params: {
            Bucket: 'orgbucket-' + em.org.partkey,
          }
        });
        s3.deleteObject({Key: key}, function (err, data) {
          if (err) {
            return alert("There was an error deleting your photo: ", err.message);
          }
          em.files.splice(i, 1)
        });
      },
      newFiles(event) {
        let em = this
        setTimeout(function () {
          event.forEach(function (f) {
            em.files.unshift(f)
          })
        }, 1000)

      },
      onCopy(e) {
        this.activecopy = (this.activecopy === e.text) ? undefined : e.text
      },
      onError(e) {
        console.log(e)
      },
      setSelected(e) {
        console.log(e)
        if(e.filetype==='pdf'){
          window.open(e.uri,'_blank')
          return;
        }else if(e.filetype==='ics'||e.filetype==='calendar'){
          let uri = e.uri.replace('https','webcal')
          window.open(uri, '_blank')
          return;
        }
        this.activeinfo = e
        this.infodialog = true
      },
      async sendTwil(){
        let data = {
          "data": "Hihi",
          "body": "Hihi",
          "media": " https://api.twilio.com/2010-04-01/Accounts/AC88b7e0638c6d9f31e6ac00d191305b5d/Messages/MMcbeed31452b29d2fef6cdb205d4ca331/Media/ME0da9e78942f40033f26af47623af8a44",
          "messagesid": "MMcbeed31452b29d2fef6cdb205d4ca331",
          "from": "+16025026839",
          "to": "+16024973822"
        }
        let resp = await fetch('http://localhost:3002/api/bandwidth/incomingmms',{
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        console.log(resp)
      }
    }
  }
</script>

<style scoped>
    .selected {
    @extend . font-weight-black
    }
    a{
        text-decoration: none;
        border: solid thin #888888;
        border-radius: 4px;
        padding-left:4px;
        padding-right: 4px;
    }
    .closebtn {
        position: absolute;
        top: 10px;
        right: 10px;
        box-shadow: 0 0 5px white;
        border: solid thin black;
        border-radius: 15px;
        background-color: transparent;
    }
</style>